import { Link } from "react-router-dom";
import useGetImages from "../hooks/useGetImages";
import { useTheme } from "../context/ThemeContext";
import React, { useRef, useState } from "react";

const ProductCard = ({ item, id }) => {
  const theme = useTheme();
  const cardRef = useRef(null);
  const { image: uri } = useGetImages("product_pictures", id, item?.URUN_KOD, {
    observeRef: cardRef,
  });
  const [showAll, setShowAll] = useState(false);
  const formatDescription = (text) => {
    if (typeof text !== "string") return text;
    return text
      .replace(/\u200B/g, "") // Zero-width space temizle
      .replace(/\s+/g, " ") // Çoklu boşlukları tek boşluğa indir
      .replace(/([a-zçğıöşü])([A-ZÇĞİÖŞÜ])/g, "$1 $2") // Küçük+büyük harf arası boşluk
      .replace(/([,.;:!?])(?!\s)/g, "$1 ") // Noktalama sonrası boşluk ekle
      .replace(/([,.;:!?])/g, "$1\u200B") // Line-break için zero-width space
      .trim();
  };
  const getPreviewText = (text, maxLength) => {
    if (typeof text !== "string" || text.length <= maxLength) return text;
    const sliced = text.slice(0, maxLength + 1);
    const lastBreak = Math.max(
      sliced.lastIndexOf(" "),
      sliced.lastIndexOf(","),
      sliced.lastIndexOf("."),
      sliced.lastIndexOf(";"),
      sliced.lastIndexOf(":")
    );
    const cutIndex = lastBreak > 0 ? lastBreak : maxLength;
    return `${text.slice(0, cutIndex).trim()}...`;
  };
  // console.log('item', item)
  if (!item) return null;

  const description = item?.URUN_ACIKLAMA || "";
  const previewText = getPreviewText(description, 70);
  const shouldToggle = description.length > previewText.length;

  return (
    <Link
      ref={cardRef}
      to={`/product/${item?.URUN_KOD}`}
      className="flex flex-col bg-white rounded-lg shadow-lg overflow-hidden px-2 py-3 my-2 no-underline"
    >
      <h2 className="text-[14px] font-semibold text-zinc-700">
          {item?.URUN_ADI}
        </h2>
        <div  className="flex flex-row">
          <div className="w-2/4">
        
        <p className="text-xs text-zinc-700 whitespace-normal break-normal !mb-0">
          {formatDescription(showAll ? description : previewText)}
        </p>
        {shouldToggle && (
          <button
            type="button"
            onClick={(event) => {
              event.preventDefault();
              setShowAll((value) => !value);
            }}
            className={`text-xs ${theme.primary.text} font-semibold mt-1`}
          >
            {showAll ? "Daha az" : "Devamini gor"}
          </button>
        )}

        <p className={`font-bold mt-2 ${theme.primary.text}`}>₺ {item?.FIYATI}</p>
      </div>
      <div className="w-2/4 ml-1 flex flex-row justify-end">
        {!!uri && (
          <img
            src={uri}
            alt={item?.URUN_ADI}
            className="object-cover h-[140px] w-[140px] rounded"
          />
        )}
      </div></div>
      
    </Link>
  );
};

export default ProductCard;
